export const promptStyle = {
    background: 'linear-gradient(to right, #5637ee 0%, #6da7d0 100%)',
    color: 'white',
    fontSize: '12px',
    fontWeight: '500',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    padding: '10px',
    width: '100%',
    textAlign: 'center',
    marginBottom: '15px',
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
}

export const buttonStyle = {
    background: 'linear-gradient(to right, #5637ee 0%, #6da7d0 100%)',
    color: 'white',
    fontWeight: 600,
    borderRadius: '50px',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'none',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
    transition: 'all 0.3s ease',
    fontFamily: "'Inter', sans-serif",
    '&:hover': {
        background: 'linear-gradient(to right, #4a2fd9 0%, #5e91b8 100%)',
        transform: 'translateY(-2px)',
        boxShadow: '0 12px 25px rgba(0, 0, 0, 0.2)'
    },
    '@media (max-width: 480px)': {
        padding: '8px 16px',
        fontSize: '0.9rem',
        minWidth: '160px',
    },
    '@media (min-width: 481px) and (max-width: 768px)': {
        padding: '10px 20px',
        fontSize: '0.95rem',
        minWidth: '180px',
    },
    '@media (min-width: 769px)': {
        padding: '12px 24px',
        fontSize: '1rem',
        minWidth: '200px',
    }
}
